import { fontSize12 } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import { grayFont } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

import theme from "../../../../js/shared/new-theme"

export const tooltipStyle = (color) => `
	.custom-tooltip-theme {
		color: ${color} !important;
	}

	.icon-default {
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid ${theme.palette.gray[600].value};
		border-radius: 30px;
		height: 16px;
		width: 16px;

		p {
			font-family: ${theme.font.family};
			font-size: ${fontSize12};
			color: ${theme.palette.gray[600].value};
			margin: 0;
		}
	}
`;